<template>
  <div class="filters-aside">
    <!-- Reset-->
    <button
      class="filters-aside__reset"
      @click="resetFilters"
      v-if="hasActiveFilters || oldSelectedSort !== null"
    >
      <span class="text-base2" v-html="$t('common.cancellaFiltri')" />
    </button>

    <!-- Filtri -->
    <div class="filters-aside__lists">
      <div class="filters-aside__lists__scroller">
        <FiltersList
          v-for="(filter, index) in computedListFilters"
          :key="index"
          :slug="filter.field_name"
          :filters="filter.counts"
          :selected="selectedFilters[filter.field_name] || []"
          @update:filter="updateFilters"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { markDisabled, parseQueryFilters } from '~/assets/js/utils/algolia.js'

const emit = defineEmits(['update:filters', 'save:filters'])

const props = defineProps({
  filters: Array,
  staticFilters: {
    type: Array,
    default: () => [],
  },
  sorts: Array,
})

const route = useRoute()

// Initialize selected filters from route query
const selectedFilters = ref(
  route.query?.filters ? parseQueryFilters(route.query.filters) : {},
)

// Check if there are any active filters
const hasActiveFilters = computed(() => {
  return Object.values(selectedFilters.value).some(
    (filter) => filter.length > 0,
  )
})

const selectedSort = ref(null)
const oldSelectedSort = ref(null)

// Compute the list of filters
const computedListFilters = computed(() => {
  return markDisabled(props.staticFilters, props.filters)
})

// Update filters and emit event
const updateFilters = (filter) => {
  selectedFilters.value = {
    ...selectedFilters.value,
    ...filter,
  }
  emit('update:filters', { selectedFilters: selectedFilters.value })
}

// Reset filters and emit event
const resetFilters = () => {
  selectedFilters.value = {}
  selectedSort.value = null
  oldSelectedSort.value = selectedSort.value

  emit('update:filters', {
    selectedFilters: selectedFilters.value,
    selectedSort: selectedSort.value,
  })
}
</script>

<script>
export default {
  name: 'FiltersAside',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
